import React from 'react';
import { i18n } from '@lt/localization';
import { Loader as LoaderIcon } from '@lt/components/icons-react/rebrand';
import styles from './TouristsFormLoader.module.css';

export const TouristsFormLoader = () => (
  <div className={styles.loaderContainer}>
    <LoaderIcon className={styles.loader} />
    <span className={styles.text}>
      {i18n.t('checkout.touristForm.loading')}
    </span>
  </div>
);
